







import Vue from 'vue';
import { IState } from '../store/state';

interface NoBoxComputed {
	text: string;
	title: string;
}

export default Vue.extend<{}, {}, NoBoxComputed, {}>({
    computed: {
        text() {
            return (this.$store.state as IState).strings.yes.sent.text.replace(/\n/g, '<br>')
		},
		title() {
			return (this.$store.state as IState).strings.yes.sent.title
		}
    }
})
